import React from 'react';

import PropTypes from 'prop-types';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
} from '@mui/material';
import { Form, Formik } from 'formik';

import dialog from 'assets/theme/components/dialog';
import dialogTitle from 'assets/theme/components/dialog/dialogTitle';
import dialogContent from 'assets/theme/components/dialog/dialogContent';
import dialogActions from 'assets/theme/components/dialog/dialogActions';

import MDBox from 'shared/components/MDBox';
import MDTypography from 'shared/components/MDTypography';
import MDButton from 'shared/components/MDButton';
import FormField from 'shared/components/form_field';
import toastError from 'shared/components/snackbar/error/toastError';
import toastSuccess from 'shared/components/snackbar/success/toastSuccess';
import localFilePatientsService from 'shared/services/local_file_patients/local_file_patients.service';

const Transition = React.forwardRef((props, ref) => (
  <Slide direction='up' ref={ref} {...props} />
));

function ModalEditFile({ open, onClose, fileData, onSuccess }) {
  const getInitialValues = () => {
    if (fileData?.created_at) {
      const dateStr = fileData.created_at.split('T')[0];
      return { date: dateStr };
    }
    return { date: '' };
  };

  const handleSubmit = async (values, actions) => {
    try {
      await localFilePatientsService.edit(fileData.uuid, { date: values.date });
      toastSuccess('Arquivo editado com sucesso');
      if (onSuccess) onSuccess();
      onClose();
    } catch (e) {
      toastError(e.message);
    }
  };

  const handleOnClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleOnClose}
      TransitionComponent={Transition}
      sx={dialog}
      fullWidth
      maxWidth='sm'
    >
      <DialogTitle sx={dialogTitle}>
        <MDBox
          display='flex'
          justifyContent='space-between'
          alignItems='center'
        >
          <MDTypography
            color='text'
            sx={{ fontWeight: 'bold', fontSize: '16px' }}
          >
            Editar arquivo
          </MDTypography>

          <IconButton onClick={handleOnClose}>
            <MDTypography color='text'>X</MDTypography>
          </IconButton>
        </MDBox>
      </DialogTitle>

      <Formik
        initialValues={getInitialValues()}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, errors, touched, setFieldValue }) => {
          const { date } = values;

          return (
            <Form>
              <DialogContent sx={{ ...dialogContent, paddingBottom: 3 }}>
                <MDBox>
                  <MDTypography
                    color='text'
                    sx={{ fontSize: 14, marginBottom: 2 }}
                  >
                    <strong>Nome:</strong>{' '}
                    <MDTypography variant='regular' sx={{ fontSize: 12 }}>
                      {fileData?.name}
                    </MDTypography>
                  </MDTypography>
                  <FormField
                    fieldShrink
                    name='date'
                    label='Data do arquivo'
                    type='date'
                    value={date}
                    onChange={(e) => setFieldValue('date', e.target.value)}
                    error={errors.date && touched.date}
                    success={date.length > 0 && !errors.date}
                  />
                </MDBox>
              </DialogContent>

              <DialogActions sx={{ ...dialogActions }}>
                <MDButton
                  color='dark'
                  variant='outlined'
                  onClick={handleOnClose}
                >
                  cancelar
                </MDButton>
                <MDButton color='primary' type='submit'>
                  salvar
                </MDButton>
              </DialogActions>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
}

ModalEditFile.defaultProps = {
  open: false,
  onClose: () => {},
  fileData: null,
  onSuccess: () => {},
};

ModalEditFile.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  fileData: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default ModalEditFile;
